import { render } from "./AccountViewPage.vue?vue&type=template&id=82268840&scoped=true"
import script from "./AccountViewPage.vue?vue&type=script&lang=js"
export * from "./AccountViewPage.vue?vue&type=script&lang=js"

import "./AccountViewPage.vue?vue&type=style&index=0&id=82268840&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82268840"]])

export default __exports__